import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    componentDidMount() {
        const number = this.props.index + 1;

        if (this.props.story && this.props.story.title) {
            const action = this.props.logged_in ? 'LI Impression-' : 'LO Impression-';

            this.props.trackEvent(['Top Stories', action + number, this.props.story.title]);
        }
    }

    render({ story, index, img_size }) {
        if (!story) {
            return (<top-story />);
        }

        const number = index + 1;
        const alt = story.image_alt || story.title;
        const src = 'https://gfx.tarot.com/images/feeds/' + img_size + '/' + story.picture_frag + '-' + img_size
        + '.jpg';

        return (
            <promoted-content-story class='small-12 medium-6 columns text-link-undecorated'>
                <a
                  class='text-link-undecorated promoted_content_link'
                  onClick={() => this.trackClick(story.title, number)}
                  href={story.url}
                  title={story.title}
                >
                    <img alt={alt} class='promoted_content_img' src={src} />
                    <h2 class='text-header-4 promoted_content_headline'>{ story.title }</h2>
                </a>
            </promoted-content-story>
        );
    }

    trackClick = (label, number) => {
        const action = this.props.logged_in ? 'LI Click-' : 'LO Click-';

        this.props.trackEvent(['Top Stories', action + number, label]);
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: payload => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/content/promoted-story.js